import * as types from './mutationTypes'

const matutaions = {
	//【加入单位】设置
	[types.SETCOMPANYSTEP](state, {step, companyName, company_id, type}){
		state.companyStep.step = step;
		state.companyStep.companyName = companyName;
		state.companyStep.company_id = company_id;
		state.companyStep.type = type;
	},

	//【公共数据】获取和设置
	[types.SETCOMMONDATA](state, data){
		state.commonData = data;
	},

	//【待处理】获取和设置
	[types.SETCOUNTWAITTOHEADER](state, data){
		state.countWaitToHeadle = data;
	},
    /**
     * 单位所有用户备选项设置
     * @param   state vuex参数
     * @param  data 人员列表
     */
	[types.SETCOMPANYUSERLIST](state,data){
	    state.companyUserList = [...data];
    },
    /**
	 * 设置地区备选项
     * @param {object} state vuex参数
     * @param {array}  data 列表项
     */
	[types.SETADDRESSLIST](state,data={"index":"",list:[]}){
		let obj = state.addressList;
		obj[`address_${data.index.toString()}`] = [...data.list];
		state.addressList = Object.assign({}, obj );
	}
};

export default matutaions


// WEBPACK FOOTER //
// ./src/store/mutations.js